<template>
  <div class="spu-group" v-if="showModule">
    <el-card
      shadow="never"
      v-loading="filterLoading"
      class="card-init spu-filter"
    >
      <div class="spu-title">
        <span class="spu-title-left">筛选条件</span>
        <span
          class="spu-title-right"
          :class="{ 'is-disabled': attributeValueIdList.length === 0 }"
          @click="clearSelection"
          >清空筛选结果</span
        >
      </div>
      <div class="attribute-wrap-container light-scrollbar">
        <div class="attr-no" v-if="filterList.length === 0">暂无筛选条件</div>
        <div
          class="attribute-wrap"
          :class="{ collapse: item.collapse }"
          v-for="(item, index) in filterList"
          :key="index"
        >
          <div class="wrap-title" @click="collapse(item)">
            <div class="wrap-title-left">{{ item.name }}</div>
            <div class="wrap-title-right">
              <i class="el-icon-arrow-down"></i>
            </div>
          </div>
          <div class="wrap-content">
            <div
              class="attribute-item"
              :class="{ active: !!attr.selected }"
              v-for="(attr, attrIndex) in item.attributeValueWithSelectedList"
              :key="attrIndex"
              @click="doSearchByAttr(attr)"
            >
              <Tooltips :innerContent="attr.name" />
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="never" v-loading="loading" class="card-init spu-skus">
      <div class="spu-title">
        <span class="spu-title-left">其他所有型号</span>
        <!-- <span class="spu-title-right"
          >收起所有<i class="el-icon-d-arrow-left"></i
        ></span> -->
      </div>
      <div class="spu-list-wrap light-scrollbar">
        <div class="spu-list" v-for="(item, index) in list" :key="index">
          <div class="sku-img" @click="goDetail(item)">
            <goodImg v-if="item.fileUrl" :img="item.fileUrl"></goodImg>
            <img v-else src="@/assets/img/bitmap.png" width="140px" />
            <div
              class="tagList"
              v-if="item.tagNameList && item.tagNameList.length"
            >
              <el-tag
                v-for="(itm, index) in item.tagNameList"
                :key="index"
                size="mini"
                style="margin-right: 3px"
                type="danger"
                effect="dark"
              >
                {{ itm }}
              </el-tag>
            </div>
          </div>
          <div class="sku-info">
            <div class="sku-title" @click="goDetail(item)">
              {{ item.skuName }}
            </div>
            <div class="sku-item">
              商品编码：<Tooltips :innerContent="item.skuCode || '-'" />
            </div>
            <div class="sku-item">
              型号：<Tooltips :innerContent="item.model || '-'" />
            </div>
            <div class="sku-item">
              数量：
              <el-tooltip
                placement="top"
                :content="`最小起订量${item.moq || 1}, 最小包装量${
                  item.sellingUnitStepSize || 1
                }`"
              >
                <span>
                  <el-input-number
                    size="mini"
                    v-model="item.count"
                    :step="1"
                    :min="1"
                    :max="999999999"
                    :precision="0"
                  ></el-input-number>
                </span>
              </el-tooltip>
            </div>
            <div class="sku-item">
              商品货号：<Tooltips
                :innerContent="item.supplyCommodityCode || '-'"
              />
            </div>
            <div
              class="sku-item"
              :class="{
                hidden: [null, undefined, ''].includes(item.deliveryTime),
              }"
            >
              供货周期：{{ item.deliveryTime }} 个工作日
            </div>
            <div class="sku-item">
              价格：

              <div
                class="price price_text"
                v-show="
                  (item.commodityType &&
                    item.commodityType.indexOf('非标') > -1) ||
                  item.isSellingPriceExpire
                "
              >
                {{ $t("home.rfq") }}
              </div>
              <good-price
                v-show="
                  item.commodityType &&
                  item.commodityType.indexOf('非标') === -1 &&
                  !item.isSellingPriceExpire
                "
                :price="Number(item.sellingPrice) || 0"
              ></good-price>
              <div class="sku-item">
                <span style="padding: 0 2px">/</span
                ><Tooltips :innerContent="item.sellingUnit || '-'" />
              </div>
            </div>
          </div>
          <div
            class="sku-opt"
            v-if="
              (item.commodityType && item.commodityType.indexOf('非标') > -1) ||
              item.isSellingPriceExpire
            "
          >
            <el-button
              class="buynow"
              style="margin-bottom: 10px"
              @click="goInquiry(item)"
              type="primary"
              size="small"
              plain
              >询价</el-button
            >
            <br />
            <el-button
              class="buynow"
              @click="addCart(2, item)"
              type="primary"
              size="small"
              plain
              >加入询价篮</el-button
            >
          </div>
          <div
            class="sku-opt"
            v-if="
              item.commodityType &&
              item.commodityType.indexOf('非标') === -1 &&
              !item.isSellingPriceExpire
            "
          >
            <el-button
              class="addcart"
              style="margin-bottom: 10px"
              @click="buySku(item)"
              type="danger"
              size="small"
              plain
              >立即购买</el-button
            >
            <br />
            <el-button
              class="buynow"
              @click="addCart(1, item)"
              type="warning"
              size="small"
              plain
              >加入购物车</el-button
            >
          </div>
        </div>
      </div>
      <el-pagination
        class="spu-pagination"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="limit"
        :total="total"
        :pager-count="5"
        layout="total, prev, pager, next, sizes, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import goodImg from '@/components/img'
import Tooltips from '@/components/tooltipShow'
import GoodPrice from '@/components/good-price'
import { getAccessToken } from '@/utils/userInfo'
import { openOther } from '@/utils'
export default {
  components: {
    goodImg,
    Tooltips,
    GoodPrice
  },
  props: {
    skuId: {
      type: String,
      default: ''
    }
  },
  name: '',
  data () {
    return {
      loading: false,
      filterLoading: false,
      pageSizes: [5, 15, 30, 60], // 设置分页数量
      page: 1,
      limit: 5,
      total: 0,
      list: [],
      filterList: [],
      attributeValueIdList: [],
      showModule: false
    }
  },
  // watch: {
  //   groupId: {
  //     immediate: true,
  //     handler () {
  //       this.getFilter()
  //       this.getList()
  //     }
  //   }
  // },
  computed: {
    groupId () {
      return this.$route.query.groupId
    }
  },
  activated () {},
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getFilter()
      this.getList(true, true)
    },
    clearSelection () {
      if (this.attributeValueIdList.length === 0) return
      this.attributeValueIdList = []
      this.getFilter()
      this.getList()
    },
    doSearchByAttr (attr) {
      if (this.attributeValueIdList.includes(attr.attributeValueId)) {
        const attrIndex = this.attributeValueIdList.findIndex(
          (item) => item === attr.attributeValueId
        )
        this.attributeValueIdList.splice(attrIndex, 1)
      } else {
        this.attributeValueIdList.push(attr.attributeValueId)
      }
      this.getFilter()
      this.getList()
    },
    // 获取筛选
    getFilter () {
      this.filterLoading = true
      this.$http
        .post('/front/commodity-user/web/group-condition', {
          groupId: this.groupId,
          groupSkuId: this.$route.query.skuId || this.skuId || undefined,
          boutiqueCategoryId: this.$route.query.boutiqueCategoryId || undefined,
          attributeValueIdList: this.attributeValueIdList
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.filterList = res.data.attributeWithSelectedList || []
            this.attributeValueIdList = []
            this.filterList.forEach((item) => {
              item.attributeValueWithSelectedList.forEach((attr) => {
                if (attr.selected) {
                  this.attributeValueIdList.push(attr.attributeValueId)
                }
              })
            })
          }
        })
        .catch(() => {})
        .finally(() => {
          this.filterLoading = false
        })
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page = 1
      this.limit = val
      // 如果是前端分页
      this.getList()
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page = val
      this.getList(true)
    },
    getList (t, init = false) {
      return new Promise((resolve) => {
        if (t !== true) {
          this.page = 1
        }

        this.loading = true
        this.$http
          .post('/front/commodity-user/web/group-sku-list', {
            page: this.page,
            limit: this.limit,
            groupId: this.groupId,
            groupSkuId: this.$route.query.skuId || this.skuId || undefined,
            boutiqueCategoryId:
              this.$route.query.boutiqueCategoryId || undefined,
            attributeValueIdList: this.attributeValueIdList
          })
          .then(({ data: res }) => {
            if (res.code === 0 && res.data) {
              this.total = res.data.count - 0
              this.list = (res.data.dataList || []).map((item) => {
                return {
                  ...item,
                  count: 1
                }
              })
            } else {
              this.total = 0
              this.list = []
            }
            if (init && this.list.length === 0) {
              this.showModule = false
            } else if (init && this.list.length > 0) {
              this.showModule = true
            }
          })
          .catch((e) => {})
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 新开页打开详情
    goDetail (item) {
      let url = `goodDetail?groupId=${this.groupId || ''}&spuId=${
        item.spuId || ''
      }&skuId=${item.skuId || ''}`
      if (this.$route.query.boutiqueCategoryId) {
        url += `&boutiqueCategoryId=${this.$route.query.boutiqueCategoryId}`
      }
      openOther(url)
    },
    // 折叠属性筛选项
    collapse (item) {
      if ('collapse' in item) {
        item.collapse = !item.collapse
      } else {
        this.$set(item, 'collapse', true)
      }
    },
    // shoppingType==1 是商品购物车，shoppingType==2 是询价篮
    addCart (shoppingType, item) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: item.custspId,
          skuId: item.skuId,
          goodsNum: item.count || 1
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success('购物车添加成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: item.spuId,
          goodsSkuId: item.skuId,
          goodsNum: item.count || 1,
          shoppingType: shoppingType
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )
          this.$message.success(
            `${this.$t('product.add')} ${
              shoppingType === 1
                ? this.$t('product.cart')
                : this.$t('product.blanket')
            } ${this.$t('product.success')}`
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
    buySku (item) {
      let {
        sellingUnitStepSize,
        skuName,
        moq,
        count,
        skuId,
        spuId,
        sellingPrice
      } = item
      !moq && (moq = 1)
      !sellingUnitStepSize && (sellingUnitStepSize = 1)
      if (count < +moq || count % sellingUnitStepSize !== 0) {
        this.$message.warning(
          `${skuName} 最小起订量为${
            moq || 1
          }，最小包装量为${sellingUnitStepSize}，请输入大于${
            moq || 1
          }且${sellingUnitStepSize}的倍数！`
        )
        return
      }

      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      // 校验该商品 及数量是否可以购买
      this.$http
        .post(`/front/consumer/shoppingcart/checkCommodityPromotion`, [
          {
            commodityId: skuId,
            commodityNum: count
          }
        ])
        .then(({ data: res }) => {
          if (res.code === 0) {
            // 跳转创订单页面
            this.$router.push({
              name: 'createOrder',
              query: {
                orderSource: '20',
                shoppingCart: JSON.stringify({
                  goodsSpuId: spuId,
                  goodsSkuId: skuId,
                  sellingPrice: sellingPrice,
                  goodsNum: count
                })
              }
            })
          } else {
            this.$confirm(res.message, this.$t('prompt.title'), {
              confirmButtonText: this.$t('confirm'),
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              type: 'warning'
            })
              .then(() => {})
              .catch(() => {})
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    goInquiry (item) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.$router.push({
        name: 'inquiryCreate',
        query: {
          goodList: item.spuId + ',' + item.skuId + ',' + item.count
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-init {
  /deep/ .el-card__body {
    padding: 0;
  }
}
.spu-group {
  display: flex;
  user-select: none;
  margin-top: 12px;
  .spu-filter {
    width: 240px;
    padding: 20px;

    .spu-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
      .spu-title-left {
        font-size: 16px;
        font-weight: bold;
      }
      .spu-title-right {
        font-size: 14px;
        cursor: pointer;
        color: #2a54d1;

        &.is-disabled {
          color: #c0c4cc;
          cursor: not-allowed;
        }
      }
    }
    .attribute-wrap-container {
      max-height: 585px;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 10px;
      margin-right: -10px;
      .attr-no {
        text-align: center;
        margin: 20px 0;
        font-size: 12px;
      }
    }
    .attribute-wrap {
      margin-bottom: 8px;

      &.collapse {
        .wrap-title {
          margin-bottom: 8px;
          .wrap-title-right {
            i {
              transform: rotate(180deg);
            }
          }
        }
        .wrap-content {
          height: 0;
          overflow: hidden;
          border-bottom: 1px dashed #eee;
        }
      }
      .wrap-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 14px;
        margin-bottom: 12px;
        cursor: pointer;
        .wrap-title-left {
          font-weight: bold;
        }
        .wrap-title-right {
          i {
            padding: 1px;
          }
        }
      }
      .wrap-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .attribute-item {
          border-radius: 8px;
          border: 1px solid #ccc;
          width: calc(50% - 8px);
          font-size: 12px;
          color: #666;
          text-align: center;
          height: 28px;
          line-height: 26px;
          cursor: pointer;
          margin-bottom: 12px;
          padding: 0 4px;

          &.active {
            color: #fff;
            background: #2a54d1;
            border-color: #2a54d1;
          }
        }
      }
    }
  }
  .spu-skus {
    padding: 20px;
    margin-left: 20px;
    width: calc(100% - 260px);

    .spu-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #333333;
      margin-bottom: 16px;
      .spu-title-left {
        font-size: 16px;
        font-weight: bold;
      }
      .spu-title-right {
        font-size: 14px;
        cursor: pointer;

        i {
          margin-left: 8px;
          transform: rotate(90deg);
        }
      }
    }

    .spu-list-wrap {
      max-height: 550px;
      overflow-x: hidden;
      overflow-y: auto;
      border-bottom: 1px solid #efeff2;
      padding-right: 10px;
      margin-right: -10px;
      .spu-list {
        padding-bottom: 16px;
        margin-bottom: 20px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
        .sku-img {
          width: 140px;
          height: 140px;
          margin-right: 20px;
          cursor: pointer;
          position: relative;
          .tagList {
            position: absolute;
            left: 10px;
            top: 10px;
            z-index: 1;
            width: calc(100% - 20px);

            .el-tag {
              overflow: hidden;
              max-width: 100%;
              text-overflow: ellipsis;
            }
          }
          .price {
            width: 100%;
            height: 100%;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          /deep/ .goodImg {
            width: 100%;
            height: 100%;
          }
        }

        .sku-info {
          flex: 1;
          align-self: flex-start;
          display: flex;
          flex-wrap: wrap;
          margin-right: 20px;
          user-select: text;
          .sku-title {
            font-size: 14px;
            font-weight: bold;
            color: #333333;
            margin-bottom: 12px;
            width: 100%;
            word-break: break-all;
            cursor: pointer;
          }

          .sku-item {
            height: 28px;
            line-height: 28px;
            width: 33%;
            margin-bottom: 6px;
            display: flex;
            white-space: nowrap;

            &.hidden {
              visibility: hidden;
              opacity: 0;
            }

            .price {
              display: inline-block;
              font-size: 20px;
              font-weight: 900;
              color: #e93037;
            }
          }
        }

        .sku-opt {
          .addcart {
            width: 110px;
            background: #fff;
            border: none;
            color: #ff4c2b;
            border-radius: 8px;
            border: 1px solid #ff4c2b;
            &:hover {
              background: #fff;
              color: #ff4c2b;
            }
            // color: #f47205;
          }
          .buynow {
            width: 110px;
            color: #2a54d1;
            background: #fff;
            border: none;
            border: 1px solid #2a54d1;
            border-radius: 8px;
            &:hover {
              background: #fff;
              color: #2a54d1;
            }
            // color: #f47205;
            // border: 1px solid #f47205;
          }
        }
      }
    }
    .spu-pagination {
      padding: 10px 0;
    }
  }
}
</style>
